/* RecentSearchBody.styles.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _36 = "._1bsb1osq{width:100%}";
const _35 = "._n3td1eps{padding-bottom:var(--ds-space-100)}";
const _34 = "@media (min-width:64rem){._ne9p1370:before{content:\"Clear search history\"}}";
const _33 = "._1kt91kbs:before{content:\"Clear all\"}";
const _32 = "._j6xtfqd3:active{background:var(--ds-background-neutral-subtle-pressed)}";
const _31 = "._q2bd4suz:focus-visible:not(:active){border:2px solid var(--ds-border-focused)}";
const _30 = "._19lc1eg3:hover{background:var(--ds-background-neutral-subtle-hovered)}";
const _29 = "._zulp1eps{gap:var(--ds-space-100)}";
const _28 = "._1bah1h6o{justify-content:center}";
const _27 = "._2lx21bp4{flex-direction:column}";
const _26 = "._1yt4mhsw{padding:var(--ds-space-0) var(--ds-space-100)}";
const _25 = "._1e0c116y{display:inline-flex}";
const _24 = "._vwz41j6v{line-height:1rem}";
const _23 = "._y3gn1h6o{text-align:center}";
const _22 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _21 = "._11q76ota{background:var(--ds-surface)}";
const _20 = "._80omtlke{cursor:pointer}";
const _19 = "._18u0idpf{margin-left:0}";
const _18 = "._otyridpf{margin-bottom:0}";
const _17 = "._2hwxidpf{margin-right:0}";
const _16 = "._19pkidpf{margin-top:0}";
const _15 = "._19itglyw{border:none}";
const _14 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _13 = "._1e0cglyw{display:none}";
const _12 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _11 = "._1e0c1ule{display:block}";
const _10 = "._k48p1nn1{font-weight:400}";
const _9 = "._ect48q0o{font-family:Charlie Text}";
const _8 = "._1wyboqnp{font-size:.75rem}";
const _7 = "._syaz1k3w{color:var(--ds-text-subtle)}";
import { media } from '@atlaskit/primitives/responsive';
const _6 = "._vwz4f6fq{line-height:18px}";
const _5 = "._1wpz1fhb{align-self:stretch}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1yb4{justify-content:space-between}";
const _2 = "._1yt47ahi{padding:var(--ds-space-250) var(--ds-space-250) var(--ds-space-050) var(--ds-space-300)}";
const _ = "._1e0c1txw{display:flex}";
export const SearchSubHeader = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1yt47ahi _1bah1yb4 _4cvr1h6o _1wpz1fhb _vwz4f6fq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchSubHeader.displayName = 'SearchSubHeader';
}
export const LabelMobile = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _1e0c1ule _dm25glyw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LabelMobile.displayName = 'LabelMobile';
}
export const LabelDesktop = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7, _8, _9, _10, _13, _14]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _1e0cglyw _dm251ule", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LabelDesktop.displayName = 'LabelDesktop';
}
export const ClearButton = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15, _16, _17, _18, _19, _20, _21, _22, _23, _9, _8, _10, _24, _25, _26, _27, _28, _4, _29, _30, _31, _32, _33, _34]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _11q76ota _syaz1jij _y3gn1h6o _ect48q0o _1wyboqnp _k48p1nn1 _vwz41j6v _1e0c116y _1yt4mhsw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulp1eps _19lc1eg3 _q2bd4suz _j6xtfqd3 _1kt91kbs _ne9p1370", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ClearButton.displayName = 'ClearButton';
}
export const QueriesContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_35, _36]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_n3td1eps _1bsb1osq", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  QueriesContainer.displayName = 'QueriesContainer';
}